"use strict";import{Tag as e}from"./src/Tag.js";import{defineElement as a}from"@spectrum-web-components/base/src/define-element.js";a("sp-tag",e);
//# sourceMappingURL=sp-tag.js.map
